const Backbone = require('backbone');
const queryString = require('query-string');

const Kits = require('../../collections/kits');
const ViewItemLista = require('./item-lista');

var params = queryString.parse(location.search);

var filtros = params['filtros[]'] || [];
if (typeof filtros == 'string') {
	filtros = [filtros];
}
filtros = filtros.map(function(filtro) {
	return filtro|0;
});

const View = Backbone.View.extend({
	initialize: function() {
		var that = this;
		that.collection = new Backbone.Collection();
		that.listenTo(Kits, 'update', function() {
			if (filtros.length == 0) {
				var models = Kits.models;
			} else {				
				var models = Kits.filter(function(model) {
					return model.get('filtros').reduce(function(resp, filtro){
						if (resp) return resp;
						var filtro_id = filtro.id|0;
						return (filtros.indexOf(filtro_id) != -1);
						
					},false);
				});
			}
			that.collection.add(models);
		});
		that.listenTo(that.collection, 'add', that.addKit);

		that.render();
	},
	addKit: function(model) {
		var that = this;		
		var view = new ViewItemLista({
			model: model
		});
		that.$el.append(view.$el);
	},
	render: function() {
		var that = this;
		that.$el.find('li').remove();
		Kits.each(function(model) {
			that.addKit(model);
		});
	}
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/kits/index.js
// module id = 29
// module chunks = 0